export default __webpack_public_path__ + "static/media/Gallery-13.0c95278c.jpeg";